import Analytics from "analytics";
import googleAnalytics from "@analytics/google-analytics";
import googleTagManager from "@analytics/google-tag-manager";
import clientConfig from "../../client-config";

// note: missing/broken homepage causes an unrelated analytics-core.module error
export const analytics = Analytics({
  app: "www-common-room",
  plugins: [
    googleAnalytics({
      measurementIds: [clientConfig.ga.trackingId],
      // gtag sends the initial page view on config; GA4 enhanced measurement
      // covers client-side navs (history changes), so we never call page().
      gtagConfig: { send_page_view: true },
      enabled: false,
    }),
    googleTagManager({
      containerId: clientConfig.gtm.trackingId,
      enabled: false,
    }),
  ],
});
